module.exports = __webpack_public_path__ + "img/184.ca272daf.jpg";